class RecentlyViewedController {
    /*@ngInject*/
    constructor($log, $rootScope, $timeout, RecentlyViewedService) {
        $log.debug('RecentlyViewedController initialized');
        this.$log = $log;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.recentlyViewedService = RecentlyViewedService;
    }

    loadRecentlyViewedProducts(productId, componentId) {
        this.$rootScope.$on('personalizeRequestSuccess', () => {
            this.recentlyViewedService.requestRecentlyViewedProducts(productId, componentId);
        });
    }

    hasRecentlyViewedProducts() {
        return this.recentlyViewedService.hasRecentlyViewedProducts();
    }
}

export default RecentlyViewedController;
